export enum VcareNumberType {
  Unknown = 'Unknown',
  Internal = 'Internal',
  External = 'External',
}
